import { Logout } from "@mui/icons-material";
import { logOut, selectCurrentUser } from "features/auth/authSlice";

import { useGetDashboardProfileQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Logo from "assets/images/logo.svg";

const AllProjectNavbar = () => {
  const currentUser = useSelector(selectCurrentUser);

  const RoleAcessParams = currentUser?.realm_access?.roles;
  const [apiData, setApiData] = useState([]);
  const navigate = useNavigate();

  const { data: userProfile } = useGetDashboardProfileQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (userProfile) {
      setApiData(userProfile?.data);
    }
  }, [userProfile]);
  //  console.log(FarmersData , " FarmersData")

  const auth = useAuth();
  const dispatch = useDispatch();

  const handlelogOut = (e) => {
    e.preventDefault();

    localStorage.removeItem("authState");
    localStorage.removeItem("locationStore");
    localStorage.removeItem("districtName");
    localStorage.removeItem("locationList");
    localStorage.removeItem("locationDropdown");
    localStorage.removeItem("reduxState");

    dispatch(logOut());
    auth.removeUser();
    auth.signoutRedirect({ id_token_hint: auth.user.id_token });
  };

  return (
    <div className="" style={{ background: "#fbfbfb" }}>
      <nav className="d-flex justify-content-between py-2 px-4  border-bottom  align-items-center">
        <div className="">
          <img
            // src={Logo}
            src="/assets/img/LC-logo.png"
            style={{ height: "45px", cursor: "pointer" }}
            onClick={() => navigate("/projects-dashboard")}
          />
        </div>
        <div className=" ">
          <h3 style={{ fontWeight: "800" }}>
            Integrated Command Center for Risk Intelligence (ICCRI)
          </h3>
        </div>
        <div
          className="d-flex align-items-center  "
          style={{ marginTop: "-5px" }}
        >
          <img
            src="/assets/img/leadsNexTech_Logo.jpg"
            style={{
              height: "38px",
              cursor: "pointer",
              mixBlendMode: "multiply",
            }}
          />
          <button
            onClick={handlelogOut}
            className=" rounded-1 btn bg-primary p-2 mt-2 text-white"
          >
            <Logout className="" style={{ fontSize: "13px" }} />
          </button>
        </div>
      </nav>
    </div>
  );
};

export default AllProjectNavbar;
